module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPBAMAAAAmOuNHAAAAAXNSR0IB2cksfwAAAAlwSFlzAAALEwAACxMBAJqcGAAAAC1QTFRFAAAAmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZmZ82irzAAAAA90Uk5TAFVmEYj/zCJEu5l3qjPdRjAomgAAAExJREFUeJxjYGBgVBJmAAHX0DAgyV4RqbR0ewFDaSgIBDJwRykpKakeZuAIsi7Yy7oBSJeqR5NEcxg0g+jIVatWLd3AwLDu3bt3Lw0AVLEguUUAnTcAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_trash.png
// module id = GppW
// module chunks = 0